import { useNavigate } from 'react-router-dom';
import { useSpacePath } from '../../../../hooks/useSpacePath';
import { useGetUpcomingEvents } from '../../../events/api/useGetUpcomingEvents';

export function useUpcomingEventsSection() {
  const spacePath = useSpacePath();
  const navigate = useNavigate();
  const { data: events, isLoading } = useGetUpcomingEvents();

  const items = events ?? [];

  function handleEventClick(subTopicId?: string | number) {
    if (!subTopicId) {
      return;
    }
    navigate(spacePath(`/topics/${subTopicId}`));
  }

  return {
    items,
    isLoading,
    handleEventClick,
  };
}
